var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show && _vm.message)?_c('div',{staticClass:"toast",class:{hide: !_vm.show}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }